import { Fragment } from 'react';
import { QUALITY_TIMELINE_DISABLED_HATCH } from '../../consts';
import { clampTimeRangeToDomain } from '../../lib/quality-time-range';
import { getTimelineBarPixelSpan } from '../lib/timeline-bar-pixel-span';
import { TimelineChartXScale } from '../lib/timeline-chart-scale-types';
import { StreamQualityIntervalDto } from '../../stream-quality.types';

export type TimelineDisabledAnalysisIntervalProps = {
  stationId: string;
  /** Merged ignored-hour windows where audio quality analysis was not run (clamped to visible range when painting). */
  intervals: StreamQualityIntervalDto[];
  barY: number;
  barHeight: number;
  innerWidth: number;
  xScale: TimelineChartXScale;
  visibleStart: Date;
  visibleEnd: Date;
};

/**
 * Hatched SVG rects over the station bar for disabled quality-analysis intervals, drawn under
 * issue/gap segments; pointer events disabled so overlapping bars keep hover/click.
 * Uses `QUALITY_TIMELINE_DISABLED_HATCH` for `fill` / `fillOpacity` (`DisabledHatchPatternDef` in `ReportResult`).
 */
export function TimelineDisabledAnalysisInterval({
  stationId,
  intervals,
  barY,
  barHeight,
  innerWidth,
  xScale,
  visibleStart,
  visibleEnd,
}: TimelineDisabledAnalysisIntervalProps) {
  return (
    <Fragment>
      {intervals.map((interval, i) => {
        const startAt = new Date(interval.start);
        const endAt = new Date(interval.end);
        const clamped = clampTimeRangeToDomain(startAt, endAt, visibleStart, visibleEnd);
        if (!clamped) {
          return null;
        }
        const { startX, barWidth } = getTimelineBarPixelSpan(
          xScale,
          innerWidth,
          clamped.start,
          clamped.end,
        );
        return (
          <rect
            key={`disabled-scope-${stationId}-${i}`}
            x={startX}
            y={barY}
            width={barWidth}
            height={barHeight}
            fill={QUALITY_TIMELINE_DISABLED_HATCH.fill}
            fillOpacity={QUALITY_TIMELINE_DISABLED_HATCH.fillOpacity}
            pointerEvents="none"
          />
        );
      })}
    </Fragment>
  );
}
